import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import PracticeAreasPreview from './components/PracticeAreasPreview';
import FirmOverview from './components/FirmOverview';
import TeamPreview from './components/TeamPreview';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import StickyContactButtons from './components/StickyContactButtons';
import Footer from './components/Footer';

const Homepage = () => {
  return (
    <>
      <Helmet>
        <title>Peter & Partners Advocates LLP - Expert Legal Services in Kenya</title>
        <meta name="description" content="Leading law firm in Kenya providing comprehensive legal services including corporate law, family law, property law, and criminal defense. Contact us for expert legal consultation." />
        <meta name="keywords" content="law firm Kenya, legal services Nairobi, corporate law, family law, property law, criminal defense, Peter Partners Advocates" />
        <meta property="og:title" content="Peter & Partners Advocates LLP - Expert Legal Services in Kenya" />
        <meta property="og:description" content="Leading law firm in Kenya providing comprehensive legal services with over 15 years of experience. Contact us today for professional legal consultation." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/homepage" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          <HeroSection />
          <PracticeAreasPreview />
          <FirmOverview />
          <TeamPreview />
          <TestimonialsSection />
          <ContactSection />
        </main>

        <Footer />
        <StickyContactButtons />
      </div>
    </>
  );
};

export default Homepage;